export default __webpack_public_path__ + "asset/img/no-data-v2~a809ea4e.png";